import React from "react"

const iconViewBoxes = {
  "arrow-down-wide-short": "0 0 576 512",
  "arrow-right": "0 0 448 512",
  "arrow-up": "0 0 384 512",
  "bag-shopping": "0 0 448 512",
  "book-open-cover": "0 0 640 512",
  "building-magnifying-glass": "0 0 640 512",
  "caret-right": "0 0 256 512",
  "cart-shopping": "0 0 576 512",
  "chevron-down": "0 0 512 512",
  "chevron-left": "0 0 320 512",
  "chevron-right": "0 0 320 512",
  "chevron-up": "0 0 512 512",
  "circle-dot": "0 0 512 512",
  "circle-exclamation": "0 0 512 512",
  "circle-info": "0 0 512 512",
  "file-arrow-down": "0 0 384 512",
  "iwoca-logo": "0 0 138.31 47",
  "life-ring": "0 0 512 512",
  "magnifying-glass": "0 0 512 512",
  "pen-to-square": "0 0 512 512",
  "sort-down": "0 0 320 512",
  "sort-up": "0 0 320 512",
  "square-checkbox": "0 0 448 512",
  "square-facebook": "0 0 448 512",
  "star-of-life": "0 0 512 512",
  "trash-can": "0 0 448 512",
  "triangle-exclamation": "0 0 512 512",
  "truck-fast": "0 0 640 512",
  "x-twitter": "0 0 512 512",
  bars: "0 0 448 512",
  bolt: "0 0 448 512",
  calculator: "0 0 384 512",
  calendar: "0 0 448 512",
  check: "0 0 448 512",
  circle: "0 0 512 512",
  envelope: "0 0 512 512",
  expand: "0 0 448 512",
  gift: "0 0 512 512",
  instagram: "0 0 448 512",
  linkedin: "0 0 448 512",
  lock: "0 0 448 512",
  logo: "0 0 200 73.9",
  phone: "0 0 512 512",
  question: "0 0 320 512",
  sliders: "0 0 512 512",
  snowflake: "0 0 448 512",
  spinner: "0 0 512 512",
  star: "0 0 576 512",
  tag: "0 0 448 512",
  xmark: "0 0 384 512",
  youtube: "0 0 576 512",
  plus: "0 0 640 640",
  receipt: "0 0 640 640",
  "share-nodes": "0 0 640 640",
  heart: "0 0 640 640",
  "scale-balanced": "0 0 640 640",
  "circle-arrow-down": "0 0 640 640",
  discount: "0 0 24 24",
  google: "0 0 23 23",
  "apple-logo": "0 0 20 23",
  facebook: "0 0 24 23",
  "linkedin-logo": "0 0 23 23",
  "eye-slash": "0 0 576 512",
  eye: "0 0 576 512",
  "arrow-right-from-bracket": "0 0 512 512",
  "map-marker-alt": "0 0 384 512",
  "secure-checkout": "0 0 640 640",
  user: "0 0 640 640",
}

const Icon = ({ id, width, height, ...props }) => {
  const spriteVersion = "20260605"
  const spriteUrl = `/sprite.svg?v=${spriteVersion}`

  if (!id || !Object.keys(iconViewBoxes).includes(id)) {
    return null
  }

  const viewBox = iconViewBoxes[id] || "0 0 256 512"
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <use href={`${spriteUrl}#${id}`} />
    </svg>
  )
}

Icon.displayName = "Icon"

export default Icon
